import { useState } from 'react';
import { Button } from 'react-bootstrap';
import { BarChart, Bar, Rectangle, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';

const GraficoActasPorArticulo = (props) => {
  const { data, fechasBusqueda, setData, setFechasBusqueda } = props;

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      return (
        <div
          className="custom-tooltip"
          style={{
            padding: '8px',
            color: '#f3f3f3',
            backgroundColor: '#1334C9',
            border: '1px solid #09185c',
            borderRadius: '4px',
          }}
        >
          <span className="fw-bold">{payload[0]?.payload.descripcion}</span>
          <hr style={{ borderColor: '#09185c' }} className="mb-0 mt-1" />
          <hr style={{ borderColor: '#09185c' }} className="mb-2 mt-0" />
          <ul className="fw-semibold mb-0">
            <li>
              {payload[0]?.name.replaceAll('_', ' ').toUpperCase()}: {payload[0]?.value}
            </li>
            <li className="mb-0">
              {payload[1]?.name.replaceAll('_', ' ').toUpperCase()}: {payload[1]?.value}
            </li>
          </ul>
        </div>
      );
    }

    return null;
  };

  return (
    <>
      {fechasBusqueda ? (
        <>
          <h4 className="mb-0">
            Actas pagadas y totales por articulo entre el {fechasBusqueda.fecha_inicio} y el {fechasBusqueda.fecha_fin}{' '}
          </h4>
          <Button
            className="mb-2"
            style={{ maxWidth: '320px' }}
            onClick={() => {
              setData(null);
              setFechasBusqueda(null);
            }}
          >
            Realizar otra consulta
          </Button>
        </>
      ) : null}
      <div style={{ maxWidth: '1500px', height: '500px', position: 'relative' }}>
        <ResponsiveContainer width="100%" height="100%">
          <BarChart
            width={500}
            height={300}
            data={data}
            margin={{
              top: 5,
              right: 30,
              left: 20,
              bottom: 5,
            }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis dataKey="codigo" interval="equidistantPreserveStart" />
            <YAxis />
            <Tooltip content={<CustomTooltip />} />
            <Legend verticalAlign="top" height={36} />
            <Bar
              name="Actas Pagadas"
              dataKey="actas_pagadas"
              fill="#45BBED"
              activeBar={<Rectangle fill="#D3EFFB" stroke="#45BBED" />}
            />
            <Bar
              name="Actas Totales"
              dataKey="actas_totales"
              fill="#1134C9"
              activeBar={<Rectangle fill="#A6B6F7" stroke="#1134C9" />}
            />
          </BarChart>
        </ResponsiveContainer>
      </div>
    </>
  );
};

export default GraficoActasPorArticulo;
